import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";
import { AdvancedFiltersComponent } from "./advanced-filters/advanced-filters.component";

import { ConfigurationPersonalParamsComponent } from "./configuration-personal-params.component";

const routesConfigurationPersonalParams: Routes = [
  {
    path: "",
    component: ConfigurationPersonalParamsComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
  },
  {
    path: "filtros-avanzados",
    component: AdvancedFiltersComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesConfigurationPersonalParams)],
  exports: [RouterModule],
})
export class PersonalParamsRoutingModule {}
